module.exports = __webpack_public_path__ + "static/media/mobileCranesBanner.b4b168c6.png";